import { Chip, Typography, UserTrendUpIcon } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../Translations';
import { Props } from '../AdvancedLeaderProgram';

function AppliedExperiencePlatform({ children }: Props) {
  return (
    <div className="mb-2 flex cursor-pointer">
      <Chip variant="outlined" color="teal" radius="full" className="mr-2  px-3">
        <span className="mr-2">
          <UserTrendUpIcon color="teal" />
        </span>
        <span>
          <Typography color="teal" variant="caption">
            <T kind="On-Demand Learning" />
          </Typography>
        </span>
        {children}
      </Chip>
    </div>
  );
}

export default observer(AppliedExperiencePlatform);
